<template>
  <div
    class="bg-white rounded-xl relative w-full hover:shadow transition-all duration-300 ease-in-out z-20 flex flex-col"
    :class="tenantCloud ? 'shadow overflow-hidden' : ''"
  >
    <div class="relative">
      <div
        :class="[
          post.category === 1 ? 'text-white bg-truegray-500' : '',
          post.category === 2 ? 'bg-truegray-100 text-black' : '',
          post.category === 3 ? 'bg-black text-white' : '',
        ]"
        class="mb-4 rounded py-1 px-4 absolute top-6 left-3 z-40"
      >
        <h6>{{ post.category_title }}</h6>
      </div>

      <div v-if="canShowManagerMenu" class="absolute top-4 right-3 z-50">
        <ManagerPostActionsMenu
          :parent="parent"
          :post_parent="parent + '-' + post.id"
          :status="post.status"
          :post-id="post.id"
        />
      </div>
    </div>
    <!-- Card image -->
    <div
      :style="{ backgroundImage: 'url(' + featured_image + ')' }"
      :class="[
        post.category === 3 ? 'card-img' : '',
        post.event_invalid ? 'invalid' : '',
      ]"
      class="rounded-t-xl overflow-hidden bg-cover bg-center relative h-48 w-full text-white flex items-center justify-center flex-col"
    >
      <!-- Private flag -->
      <div
        v-if="post.private"
        class="absolute bottom-3 left-3 rounded p-2 bg-cw-alt text-white z-40"
        title="Private post. Only visible to authenticated users"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          fill="currentColor"
          class="w-4 h-4"
        >
          <path
            fill-rule="evenodd"
            d="M3.28 2.22a.75.75 0 0 0-1.06 1.06l10.5 10.5a.75.75 0 1 0 1.06-1.06l-1.322-1.323a7.012 7.012 0 0 0 2.16-3.11.87.87 0 0 0 0-.567A7.003 7.003 0 0 0 4.82 3.76l-1.54-1.54Zm3.196 3.195 1.135 1.136A1.502 1.502 0 0 1 9.45 8.389l1.136 1.135a3 3 0 0 0-4.109-4.109Z"
            clip-rule="evenodd"
          />
          <path
            d="m7.812 10.994 1.816 1.816A7.003 7.003 0 0 1 1.38 8.28a.87.87 0 0 1 0-.566 6.985 6.985 0 0 1 1.113-2.039l2.513 2.513a3 3 0 0 0 2.806 2.806Z"
          />
        </svg>
      </div>
      <!-- /Private flag -->

      <!-- Author info -->
      <div
        v-if="(cloud && !author_page && !tenantCloud && !contributor) || expo"
        class="absolute top-3 right-3 cursor-pointer bg-white rounded-full flex items-center justify-center border-2 border-truegray-100 w-15 h-15 z-50 authorhello"
        @click="authorModalActive = !authorModalActive"
      >
        <div class="relative">
          <div
            v-if="post.author.logo"
            class="bg-no-repeat bg-cover bg-center w-12 h-12 rounded-full"
            :style="{
              backgroundImage: 'url(' + post.author.logo + ')',
            }"
          ></div>
          <div
            v-else
            class="flex justify-center items-center w-12 h-12 rounded-full text-cw-900"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-12 w-12"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                clip-rule="evenodd"
              />
            </svg>
          </div>

          <div
            v-if="
              post.original_contributor_author &&
              post.original_contributor_author.type !== 2
            "
            class="absolute left-10 top-0 p-1 bg-green-400 rounded-full text-white border-2 border-white"
          >
            <div class="relative group">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-2 w-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <div
                :style="{ width: 'max-content' }"
                class="absolute opacity-0 pointer-events-none group-hover:opacity-100 right-12 top-0 bg-white rounded px-4 py-2 border border-truegray-300 text-black font-primary text-center"
              >
                Verified Contributor
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Author modal -->
      <div
        :class="[
          authorModalActive
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 pointer-events-none -translate-y-8',
        ]"
        class="w-48 absolute top-24 right-3 rounded bg-white shadow authorInfoModal transform z-50 p-3 space-y-2 transition-all duration-300 ease-in-out"
      >
        <div
          class="bg-white rounded-full flex items-center justify-center border-2 border-truegray-100 w-12 h-12"
        >
          <div
            v-if="post.author.logo"
            class="bg-no-repeat bg-cover bg-center w-8 h-8 rounded-full"
            :style="{
              backgroundImage: 'url(' + post.author.logo + ')',
            }"
          ></div>
          <div
            v-else
            class="flex justify-center items-center w-8 h-8 rounded-full text-cw-900"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-8 w-8"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
        <h6
          v-if="post.author.title"
          class="truncate overflow-ellipsis w-40 text-truegray-500 text-xs"
        >
          {{ post.author.title }}
        </h6>
        <h6 v-if="post.author.post_count" class="text-cw-alt">
          Posts: {{ post.author.post_count }}
        </h6>
        <button
          v-if="post.author.site_url && !expo"
          class="btn btn-cw-300 py-3 px-3"
          @click="showProfile(post.author)"
        >
          View Posts
        </button>
      </div>

      <div
        v-if="post.category === 3 && start_date_short"
        class="text-center flex items-center justify-center leading-none z-40"
        :class="
          start_date_short === end_date_short
            ? isContributor
              ? 'text-3xl'
              : 'text-4xl'
            : isContributor
            ? 'text-xl'
            : 'text-2xl'
        "
      >
        <span :class="{ 'font-primary font-semibold': !isContributor }">{{
          start_date_short
        }}</span>
        <span
          v-if="start_date_short !== end_date_short"
          :class="['ml-2', { 'font-primary font-semibold': !isContributor }]"
          >- {{ end_date_short }}</span
        >
      </div>

      <div v-if="post.event_invalid" class="text-center z-40 px-6">
        <p class="text-red-500 font-bold">Invalid Event!</p>
        <p class="text-sm">
          This event does not contain a date. It will be hidden from your users
          until a date is added.
        </p>
      </div>

      <!--
        <a 
        v-if="post.category === 3"
        @click='viewPost(post.id)' 
        :id='post.id' 
        class="z-40 mt-3"
        :class="[cloud ? 'hover:text-cw-alt':'']"
        > View Event ></a> 
      -->
    </div>
    <!-- /Card Image -->

    <!-- Card Content -->

    <!-- New flag -->
    <div
      v-if="tenantCloud && post.new_flag"
      class="bg-red-500 text-white w-full h-6 text-xs font-bold flex items-center justify-center"
    >
      New
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        class="h-4 w-4 ml-2"
      >
        <path
          d="M15.98 1.804a1 1 0 0 0-1.96 0l-.24 1.192a1 1 0 0 1-.784.785l-1.192.238a1 1 0 0 0 0 1.962l1.192.238a1 1 0 0 1 .785.785l.238 1.192a1 1 0 0 0 1.962 0l.238-1.192a1 1 0 0 1 .785-.785l1.192-.238a1 1 0 0 0 0-1.962l-1.192-.238a1 1 0 0 1-.785-.785l-.238-1.192ZM6.949 5.684a1 1 0 0 0-1.898 0l-.683 2.051a1 1 0 0 1-.633.633l-2.051.683a1 1 0 0 0 0 1.898l2.051.684a1 1 0 0 1 .633.632l.683 2.051a1 1 0 0 0 1.898 0l.683-2.051a1 1 0 0 1 .633-.633l2.051-.683a1 1 0 0 0 0-1.898l-2.051-.683a1 1 0 0 1-.633-.633L6.95 5.684ZM13.949 13.684a1 1 0 0 0-1.898 0l-.184.551a1 1 0 0 1-.632.633l-.551.183a1 1 0 0 0 0 1.898l.551.183a1 1 0 0 1 .633.633l.183.551a1 1 0 0 0 1.898 0l.184-.551a1 1 0 0 1 .632-.633l.551-.183a1 1 0 0 0 0-1.898l-.551-.184a1 1 0 0 1-.633-.632l-.183-.551Z"
        />
      </svg>
    </div>
    <!-- /New flag -->

    <div
      :class="[tenantCloud ? 'pb-0' : '']"
      class="relative p-6 flex flex-col justify-between"
    >
      <div>
        <h6
          v-if="!tenantCloud"
          :class="[cloud ? 'text-cw-700' : 'text-primary']"
          class="uppercase mb-2"
        >
          <template v-if="post.category === 2">
            <span>{{ post.job_employer }}</span>
            <span v-if="jobTypes[post.job_type]">
              | {{ jobTypes[post.job_type].text }}
            </span>
          </template>

          <template v-else-if="post.year_tag && post.year_tag.length">
            <span v-for="(yearTag, index) in post.year_tag">
              <span v-if="index"> | </span>
              {{ yearTag }}
            </span>
          </template>
        </h6>

        <h6
          v-if="region_tag && tenantCloud"
          class="text-truegray-300 flex items-center space-x-2 mb-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            class="w-4 h-4"
          >
            <path
              fill-rule="evenodd"
              d="M9.69 18.933l.003.001C9.89 19.02 10 19 10 19s.11.02.308-.066l.002-.001.006-.003.018-.008a5.741 5.741 0 00.281-.14c.186-.096.446-.24.757-.433.62-.384 1.445-.966 2.274-1.765C15.302 14.988 17 12.493 17 9A7 7 0 103 9c0 3.492 1.698 5.988 3.355 7.584a13.731 13.731 0 002.273 1.765 11.842 11.842 0 00.976.544l.062.029.018.008.006.003zM10 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
              clip-rule="evenodd"
            />
          </svg>
          <span class="text-truegray-500 font-semibold">{{
            regionTagText
          }}</span>
        </h6>

        <h3>{{ post.title }}</h3>

        <PostTags
          v-if="post.general_tags && post.general_tags.length > 0"
          :tags="post.general_tags"
        />

        <div
          v-if="post.industry_tags && post.industry_tags.length > 0"
          class="pb-3"
        >
          <MultipleTags
            :cloud="cloud"
            :tags="post.industry_tags"
            :colour="'text-primary'"
          />
        </div>

        <!-- Event Specific -->
        <div
          v-if="post.category === 3"
          class="text-xs border-t border-truegray-300 pt-3"
        >
          <!-- Dates -->
          <div
            v-if="post.event_start_at"
            class="mb-2 flex items-center text-truegray-700"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                clip-rule="evenodd"
              />
            </svg>
            <div>
              <span>{{ post.event_start_at_ui }} </span>
              <span
                v-if="
                  post.event_end_at_ui &&
                  post.event_start_at_ui != post.event_end_at_ui
                "
              >
                - {{ post.event_end_at_ui }}
              </span>
            </div>
          </div>
          <!-- /Dates -->

          <!-- Venue Title -->
          <div
            v-if="post.event_venue_title"
            class="mb-2 flex items-center text-truegray-700 text-xs"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 mr-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                clip-rule="evenodd"
              />
            </svg>
            {{ post.event_venue_title }}
          </div>
          <!-- /Venue Title -->
        </div>
        <!-- /Event specific -->

        <!-- Job Specific -->
        <div
          v-if="post.category === 2 && post.event_end_at_ui"
          class="mb-2 flex items-center text-truegray-700 text-xs"
        >
          Application expiry : {{ post.event_end_at_ui }}
        </div>
        <!-- /Job Specific -->
      </div>

      <!-- Card base -->
      <div class="mt-auto border-t border-truegray-300 pt-3">
        <h6
          v-if="region_tag && region_tag.length > 0 && cloud"
          class="text-truegray-500"
        >
          Region:
          <span class="text-cw-alt font-semibold ml-2">{{ region_tag }}</span>
        </h6>
        <h6 v-if="!tenantCloud" class="text-truegray-400 mb-3">
          Published on {{ post.created_at_ui }}
        </h6>
        <!-- View post - link to (public) cloud - temporary (2025)! -->
        <a
          v-if="isOrganisationPublicProfileContext"
          :href="settings.cloud_url + '/cloudpost/' + post.id"
          target="_blank"
        >
          View post >
        </a>
        <a
          v-else-if="!TVMode && !tenantCloud"
          :id="post.id"
          class="z-40 pb-4"
          :class="[cloud || isContributor ? 'hover:text-cw-alt' : '']"
          @click="viewPost(post.id)"
          >View post ></a
        >
      </div>

      <!-- Tenant Cloud Base -->
      <div v-if="tenantCloud">
        <div v-if="post.statistics" class="mb-4 text-truegray-500">
          <h6 v-if="post.statistics.shares > 1">
            {{ post.statistics.shares }} schools have shared this post
          </h6>
          <h6 v-if="post.statistics.shares === 1">
            1 school has shared this post
          </h6>
          <h6 v-if="post.statistics.shares === 0">
            No schools have shared this post yet
          </h6>
        </div>
        <AuthorBadge :entity="post.author" :published-at="post.created_at_ui" />
        <a
          ref="viewPost"
          :href="settings.cloud_domain + '/cloudpost/' + post.id"
          target="_blank"
          class="hidden"
        ></a>
      </div>
    </div>

    <div
      v-if="tenantCloud"
      class="border-t border-truegray-100 mt-auto flex items-center justify-center w-full h-12 rounded-b-xl overflow-hidden"
    >
      <div
        :class="saved ? 'opacity-50' : ''"
        class="group w-1/3 relative h-full flex items-center justify-center text-truegray-500 cursor-pointer hover:bg-truegray-100 transition-all"
        @click="viewPost(post.id)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 group-hover:opacity-0"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
          <path
            fill-rule="evenodd"
            d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
            clip-rule="evenodd"
          />
        </svg>

        <p
          v-if="!thinking"
          class="opacity-0 text-center text-xs group-hover:opacity-100 absolute left-1/2 top-1/2 pointer-events-none transform translate-x-[-50%] translate-y-[-50%]"
        >
          Preview
        </p>
      </div>
      <div
        :class="[
          saved ? 'opacity-50 pointer-events-none' : '',
          draftThinking ? 'bg-cw-900' : 'bg-truegray-100 hover:bg-truegray-300',
        ]"
        class="group w-1/3 relative h-full flex items-center justify-center text-truegray-500 cursor-pointer transition-all"
        @click="saveCloudPost(post.id, post.tenant_id)"
      >
        <svg
          v-if="!draftThinking"
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 group-hover:opacity-0"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            d="M7.707 10.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V6h5a2 2 0 012 2v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h5v5.586l-1.293-1.293zM9 4a1 1 0 012 0v2H9V4z"
          />
        </svg>

        <lottie v-if="draftThinking" :options="loadingAnimationOptions" />

        <p
          v-if="!saved && !thinking && !draftThinking"
          class="opacity-0 text-center text-xs group-hover:opacity-100 absolute left-1/2 top-1/2 pointer-events-none transform translate-x-[-50%] translate-y-[-50%]"
        >
          Save to drafts
        </p>
      </div>
      <div
        class="group w-1/3 relative h-full flex items-center justify-center text-white cursor-pointer hover:bg-cw-900 transition-all"
        :class="[
          saved || thinking || settings.tenant_id === post.tenant_id
            ? 'bg-cw-900 pointer-events-none'
            : 'bg-cw-300',
        ]"
        @click="saveCloudPost(post.id, post.tenant_id, true)"
      >
        <span
          v-if="settings.tenant_id === post.tenant_id && !thinking"
          class="text-xs"
        >
          Posted by you
        </span>
        <svg
          v-if="!saved && !thinking && settings.tenant_id !== post.tenant_id"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          class="group-hover:opacity-0 w-5 h-5"
        >
          <path
            d="M3.105 2.289a.75.75 0 00-.826.95l1.414 4.925A1.5 1.5 0 005.135 9.25h6.115a.75.75 0 010 1.5H5.135a1.5 1.5 0 00-1.442 1.086l-1.414 4.926a.75.75 0 00.826.95 28.896 28.896 0 0015.293-7.154.75.75 0 000-1.115A28.897 28.897 0 003.105 2.289z"
          />
        </svg>

        <lottie v-if="thinking" :options="loadingAnimationOptions" />

        <svg
          v-if="
            (saved ||
              (settings.tenant_id === post.tenant_id &&
                post.author.type === 1)) &&
            !thinking
          "
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 group-hover:opacity-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 13l4 4L19 7"
          />
        </svg>

        <p
          v-if="!saved && !thinking"
          class="opacity-0 text-center text-xs group-hover:opacity-100 absolute left-1/2 top-1/2 pointer-events-none transform translate-x-[-50%] translate-y-[-50%]"
        >
          Save and publish
        </p>
      </div>
    </div>
    <!-- /Card Content -->

    <!-- Shared WP -->
    <div
      v-if="user && post.shared_to_wp"
      class="absolute bottom-0 right-3 flex justify-end group cursor-pointer"
    >
      <span
        aria-hidden="true"
        class="h-7 w-7 mb-4 rounded-full bg-white opacity-30"
      >
        <img src="/img/icons/wordpress.png" alt="Wordpress icon" />
      </span>
      <div
        :style="{ width: 'max-content' }"
        class="absolute opacity-0 pointer-events-none group-hover:opacity-100 right-8 bottom-4 bg-white rounded px-2 py-1 border border-truegray-300 text-black font-primary text-center text-xs"
      >
        Shared!
      </div>
    </div>

    <div
      v-if="saved && tenantCloud"
      class="saved-modal rounded-t-xl top-0 left-0 z-50 w-full absolute flex flex-col items-center justify-center space-y-3"
    >
      <h3>Post already saved</h3>
      <p>Click here to view your Cloud drafts</p>
      <p class="italic text-truegray-500 text-center px-6">
        If you used save and publish, the post will be live on your settings.
      </p>
      <button class="btn btn-trans-black" @click="goToCloudPosts">
        View Cloud Drafts
      </button>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../js/plugins/event-bus.js'
import { getTagAllRegionsDisplayValue } from '../../js/util/helper.js'
import { mapActions, mapGetters } from 'vuex'
import PostTags from '../../shared/components/PostTags.vue'
import MultipleTags from '../../shared/components/MultipleTags.vue'
import ManagerPostActionsMenu from '../tenant/ManagerPostActionsMenu.vue'
import AuthorBadge from '../../careerwise/tenant/manager/pages/cloud/AuthorBadge.vue'
import * as loadingAnimation from '../components/loading.json'
import { JOB_TYPES } from '../../js/util/constants.js'
import { post } from '../../js/api/api.js'

export default {
  components: {
    PostTags,
    MultipleTags,
    ManagerPostActionsMenu,
    AuthorBadge,
  },

  props: {
    post: { default: [] },
    tenantCloud: { default: false },
    cloud: { default: false },
    contributor: { default: false },
    author_page: { default: false },
    expo: { default: false },
    parent: { default: false },
    admin_menu: { default: true },
  },

  data() {
    return {
      loadingAnimationOptions: {
        animationData: loadingAnimation.default,
      },

      loadingAnimate: false,

      start_date_short: null,
      end_date_short: null,
      authorModalActive: false,
      featured_image: '',
      jobTypes: JOB_TYPES,
      region_tag: '',

      // tenant cloud data
      thinking: false,
      draftThinking: false,
      saved: false,
    }
  },

  computed: {
    // Set all map getters
    ...mapGetters({
      settings: 'shared/getSettings',
      client: 'shared/getClient',
      isContributor: 'shared/isContributor',
      user: 'shared/getUser',
      savedCloudPosts: 'careerwise/getSavedCloudposts',
      TVMode: 'careerwise/getTVMode',
      isPublicProfileContext: 'contributors/isPublicProfileContext',
    }),

    isOrganisationPublicProfileContext() {
      return this.isPublicProfileContext(this.$route)
    },

    canShowManagerMenu() {
      return (
        this.user && this.admin_menu && !this.isOrganisationPublicProfileContext
      )
    },

    regionTagText() {
      const defaultText = this.region_tag.text
      if (this.post.region_tag.textOptionsByCategory) {
        return getTagAllRegionsDisplayValue(this.post.category) || defaultText
      }

      return defaultText
    },
  },

  watch: {
    post: {
      handler: function (val) {
        if (val.event_start_at_ui) {
          this.start_date_short = val.event_start_at_ui.split(',')[0]
          this.end_date_short = val.event_end_at_ui.split(',')[0]
        }
        if (val.image_featured) {
          this.$set(this, 'featured_image', val.image_featured)
        } else {
          switch (val.category) {
            case 1:
              this.$set(this, 'featured_image', '/img/default-news.jpg')
              break
            case 2:
              this.$set(this, 'featured_image', '/img/default-job.png')
              break
            case 3:
              this.$set(this, 'featured_image', '/img/default-event.png')
              break
            default:
              break
          }
        }
        this.getRegion()
      },

      deep: true,
    },

    savedCloudPosts: {
      handler: function (list) {
        if (list.includes(this.post.id)) {
          this.$set(this, 'saved', true)
        } else {
          this.$set(this, 'saved', false)
        }
      },

      deep: true,
    },
  },

  mounted() {
    if (this.post.event_start_at_ui) {
      this.start_date_short = this.post.event_start_at_ui.split(',')[0]
    }

    if (this.post.event_end_at_ui) {
      this.end_date_short = this.post.event_end_at_ui.split(',')[0]
    }

    if (this.post.image_featured) {
      this.$set(this, 'featured_image', this.post.image_featured)
    } else {
      switch (this.post.category) {
        case 1:
          this.$set(this, 'featured_image', '/img/default-news.jpg')
          break
        case 2:
          this.$set(this, 'featured_image', '/img/default-job.png')
          break
        case 3:
          this.$set(this, 'featured_image', '/img/default-event.png')
          break
        default:
          break
      }
    }

    if (this.post) {
      this.getRegion()
      if (this.savedCloudPosts.includes(this.post.id)) {
        this.$set(this, 'saved', true)
      } else {
        this.$set(this, 'saved', false)
      }
    }
  },

  methods: {
    ...mapActions({
      dispatchSaveCloudPost: 'careerwise/dispatchSaveCloudPost',
    }),

    viewPost(id = 0) {
      if (this.isContributor) {
        this.$router.push({ path: `/cloud/post/${id}` })
        return
      }

      if (this.client === 'client2cloud') {
        document.body.style.overflow = 'auto'
        this.$router.push({ path: `/news/${id}` })
        return
      }

      if (this.tenantCloud) {
        this.$refs.viewPost.click()
        return
      }

      // let id = $event.target.id;
      if (this.cloud) {
        this.$router.push({ path: `/cloudpost/${id}` })
      } else {
        this.$router.push({ path: `/post/${id}` })
      }
    },

    showProfile(author) {
      if (author.type === 0) {
        this.$router.push({ path: '/organisation/' + author.id })
      } else {
        this.$router.push({ path: '/school/' + author.id })
      }
    },

    getRegion() {
      this.settings?.tag_regions?.forEach((i) => {
        if (this.post.tag_titles.includes(i.text)) {
          this.$set(this, 'region_tag', i)
        }
      })
    },

    goToCloudPosts() {
      this.$router.push({ name: 'Drafts' })
    },

    /**
     * Save cloud post to posts
     */
    async saveCloudPost(id, tenant_id, publish = false) {
      if (tenant_id === this.settings.tenant_id || this.saved) {
        return
      }
      if (publish) {
        this.$set(this, 'thinking', true)
      } else {
        this.$set(this, 'draftThinking', true)
      }
      const payload = {
        post_id: id,
        publish,
      }

      const response = await this.dispatchSaveCloudPost(payload)
      this.$set(this, 'thinking', false)
      this.$set(this, 'draftThinking', false)
      if (response) {
        this.$set(this, 'saved', true)
      } else {
        EventBus.$emit('triggerAlertResponse', {
          status: 'error',
          message: 'Failed to save post',
        })
      }
    },
  },
}
</script>

<style scoped>
.saved-modal {
  background: rgba(255, 255, 255, 0.95);
  height: calc(100% - 3rem);
}

.card-img::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
  pointer-events: none;
}

.invalid.card-img::after {
  opacity: 0.7;
}

.tag-item::after {
  position: absolute;
  right: -0.5rem;
  top: 50%;
  content: '';
  background: currentColor;
  height: 4px;
  width: 2px;
  border-radius: 6px;
  transform: translateY(-50%);
}

.tag-item:last-child::after {
  opacity: 0;
}

.authorInfoModal:after {
  position: absolute;
  content: '';
  right: 19px;
  top: -10px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 12px 16px 12px;
  border-color: transparent transparent #ffffff transparent;
}
</style>
